import { DatePicker } from 'antd'
import type { RangePickerProps } from 'antd/lib/date-picker'

export default function RangePicker(props: RangePickerProps) {
  const { RangePicker } = DatePicker
  const { format = 'D MMM', ...restProps } = props

  return (
    <RangePicker
      className="lmc-antd-date-picker"
      popupClassName="lmc-antd-date-picker-dropdown"
      format={format}
      {...restProps}
    />
  )
}
